import React from 'react'
import './PrivacyPolicy.css'
import BannerComponent from '../Common-Component/BannerComponent/BannerComponent'
import InnerPrivacyPolicy from './InnerPrivacyPolicy/InnerPrivacyPolicy'

const PrivacyPolicy = () => {
    return (
        <section className='PrivacyPolicy AboutUs'>
            <BannerComponent img="\assets\Images\PrivacyPolicy\banner.png" title="Privacy Policy" />

            <div className='container'>
                <div className='below_banner_section'>
                    <InnerPrivacyPolicy/>
                </div>
            </div>

        </section>
    )
}

export default PrivacyPolicy
